import React from 'react';
import { ShieldAlert, AlertCircle } from 'lucide-react';

/**
 * Renders "F. Sygnały do weryfikacji" inside an existing demo output card.
 *
 * Visual style: neutral/cyan emphasis (NOT red danger). These are review
 * signals, not accusations. Framing + disclaimer are always rendered, with
 * fallbacks if the API omits them.
 *
 * Props:
 *   signals    — string[] (output.reviewSignals)
 *   framing    — string  (output.reviewSignalsFraming, optional)
 *   disclaimer — string  (output.reviewSignalsDisclaimer, optional)
 *   testidPrefix — e.g. "compliance-output" or "gov-output"
 *   label      — the label to render (defaults to "F. Sygnały do weryfikacji")
 */
const DEFAULT_FRAMING = 'To są sygnały do weryfikacji, nie stwierdzenie nadużycia.';
const DEFAULT_DISCLAIMER =
  'Wykryte sygnały mają charakter pomocniczy i organizacyjny. Nie stanowią ' +
  'stwierdzenia nadużycia, winy ani decyzji prawnej. Wynik wymaga weryfikacji ' +
  'przez człowieka.';

const ReviewSignalsSection = ({
  signals,
  framing,
  disclaimer,
  testidPrefix,
  label = 'F. Sygnały do weryfikacji',
}) => {
  const list = Array.isArray(signals) ? signals : [];
  const safeFraming = (framing && framing.trim()) || DEFAULT_FRAMING;
  const safeDisclaimer = (disclaimer && disclaimer.trim()) || DEFAULT_DISCLAIMER;

  return (
    <div
      className="hussar-compliance-output-section hussar-review-signals"
      data-testid={`${testidPrefix}-signals`}
    >
      <div className="hussar-compliance-output-section-label">
        <ShieldAlert className="w-4 h-4" /> {label}
      </div>
      <div className="hussar-review-signals-badge" data-testid={`${testidPrefix}-signals-badge`}>
        Sygnały procesowe · AI wskazuje sygnały. Człowiek prowadzi ocenę.
      </div>
      <p className="hussar-tc-meta" data-testid={`${testidPrefix}-signals-framing`}>
        {safeFraming}
      </p>
      {list.length === 0 ? (
        <p
          className="hussar-pol-op-body"
          style={{ marginTop: '8px' }}
          data-testid={`${testidPrefix}-signals-empty`}
        >
          Brak dodatkowych sygnałów w danych demonstracyjnych.
        </p>
      ) : (
        <ul
          className="hussar-pol-op-bullets"
          style={{ marginTop: '8px' }}
          data-testid={`${testidPrefix}-signals-list`}
        >
          {list.map((s, i) => (
            <li key={s} data-testid={`${testidPrefix}-signal-${i}`}>{s}</li>
          ))}
        </ul>
      )}
      <p
        className="hussar-tc-meta"
        style={{ marginTop: '12px' }}
        data-testid={`${testidPrefix}-signals-disclaimer`}
      >
        <AlertCircle className="w-3 h-3 inline-block mr-1" />
        {safeDisclaimer}
      </p>
    </div>
  );
};

export default ReviewSignalsSection;
